/**
 * Wagtail rich text titles are usually a single `<p>...</p>`. For a semantic page
 * heading, use the paragraph’s inner HTML inside an `<h1>` (do not nest `<h1>` in v-html).
 */
export function normalizeWagtailRichTextHtml(html: string | null | undefined): string {
  if (html == null || typeof html !== 'string') return '';
  const trimmed = html.trim();
  if (!trimmed) return '';
  let normalized = trimmed.normalize('NFKC');
  normalized = normalized.replace(/font-family\s*:\s*[^;"']+;?\s*/gi, '');
  normalized = normalized.replace(/\sstyle=(["'])\s*\1/g, '');
  return normalized;
}

export function wagtailRichTitleInnerHtmlForH1(html: string): string {
  const s = normalizeWagtailRichTextHtml(html);
  const single = s.match(/^<p(\s[^>]*)?>([\s\S]*)<\/p>\s*$/i);
  if (single?.[2] != null) return single[2];
  const first = s.match(/^<p(\s[^>]*)?>([\s\S]*?)<\/p>/i);
  if (first?.[2] != null) return first[2];
  return s;
}

/** Plain text from a small HTML fragment (e.g. Wagtail rich text). */
export function stripHtmlToText(html: string | null | undefined): string {
  if (html == null || typeof html !== 'string') return '';
  const trimmed = normalizeWagtailRichTextHtml(html);
  if (!trimmed) return '';
  if (typeof document !== 'undefined') {
    const d = document.createElement('div');
    d.innerHTML = trimmed;
    return (d.textContent ?? '').replace(/\s+/g, ' ').trim();
  }
  return trimmed.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}
